/* eslint-disable react/prop-types */
import StatusComponent from "./status";
import { useState } from "react";

const DATE_PLACEHOLDER = new Date("01/01/2023");

function Status({ announcement, updateAnnouncement }) {
  const [openingDate, setOpeningDate] = useState(
    announcement.openingDate
      ? new Date(announcement.openingDate)
      : DATE_PLACEHOLDER
  );

  const [reportingDate, setReportingDate] = useState(
    announcement.reportingDate
      ? new Date(announcement.reportingDate)
      : DATE_PLACEHOLDER
  );

  const [closingDate, setClosingDate] = useState(
    announcement.closingDate
      ? new Date(announcement.closingDate)
      : DATE_PLACEHOLDER
  );

  const handleOpeningDateChange = (date) => {
    setOpeningDate(date);
    updateAnnouncement("openingDate", date.getTime(), announcement);
  };

  const handleReportingDateChange = (date) => {
    setReportingDate(date);
    updateAnnouncement("reportingDate", date.getTime(), announcement);
  };

  const handleClosingDateChange = (date) => {
    setClosingDate(date);
    updateAnnouncement("closingDate", date.getTime(), announcement);
  };

  return (
    <StatusComponent
      openingDate={openingDate}
      reportingDate={reportingDate}
      closingDate={closingDate}
      onOpeningDateChange={handleOpeningDateChange}
      onReportingDateChange={handleReportingDateChange}
      onClosingDateChange={handleClosingDateChange}
      isOpeningDateValid={openingDate !== DATE_PLACEHOLDER}
      isReportingDateValid={reportingDate !== DATE_PLACEHOLDER}
      isClosingDateValid={closingDate !== DATE_PLACEHOLDER}
    />
  );
}

export default Status;
